import { combineReducers } from 'redux';

import dialogSendPayment from './dialogSendSlip';

const reducer = combineReducers({
  [dialogSendPayment.name]: dialogSendPayment.reducer,
});

export default reducer;
